import { lazy, useEffect, useState } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

import useAuth from '../hooks/useAuth';
import UserAccountProfileChangePassword from 'views/application/change-password/UserAccountProfileChangePassword';

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

const Managers = Loadable(lazy(() => import('views/application/users/list/Style1')));
const AddManager = Loadable(lazy(() => import('views/application/users/create')));
const EditManager = Loadable(lazy(() => import('views/application/users/edit')));

const CompanyUsers = Loadable(lazy(() => import('views/application/company-users/list/Style1')));
const AddUser = Loadable(lazy(() => import('views/application/company-users/create')));
const EditUser = Loadable(lazy(() => import('views/application/company-users/edit')));
// ==============================|| MAIN ROUTING ||============================== //

export default function MainRoutes() {
    const { user } = useAuth();
    const [u, setU] = useState(null);

    useEffect(() => {
        setU(user);
    }, [user]);

    if (u && u.type === 'manager') {
        return {
            path: '/',
            element: (
                <AuthGuard>
                    <MainLayout />
                </AuthGuard>
            ),
            children: [
                {
                    path: '/',
                    element: <CompanyUsers />
                },
                {
                    path: '/add-user',
                    element: <AddUser />
                },
                {
                    path: '/edit-user/:id',
                    element: <EditUser />
                },
                {
                    path: '/user/account-profile/change-password',
                    element: <UserAccountProfileChangePassword />
                }
            ]
        };
    }
    return {
        path: '/',
        element: (
            <AuthGuard>
                <MainLayout />
            </AuthGuard>
        ),
        children: [
            {
                path: '/',
                element: <Managers />
            },
            {
                path: '/managers',
                element: <Managers />
            },
            {
                path: '/add-manager',
                element: <AddManager />
            },
            {
                path: '/edit-manager/:id',
                element: <EditManager />
            }
        ]
    };
}
